<template>
  <div class="homePage">
    <div class="school-item" v-for="item in bindSchoolList" :key="item.id">
      <img :src="userInfo.headImgUrl" alt />
      <div>
      <div class="names">
        <div class="nick-name">{{userInfo.nickname}}</div>
        <div class="school-name">{{item.schoolName}}</div>
      </div>
      <div class="buttons">
        <el-button type="success" round size="small" v-if="item.ifOnLineLetOut == 'Y'" @click="clickAfterSchool(item)">放 学</el-button>
        <el-button type="primary" round size="small" @click="clickLook(item)">查 看</el-button>
        <el-button type="danger" round size="small" @click="deleteBind(item)">删 除</el-button>

        <!-- <span @click="clickAfterSchool(item)">放学</span>
        <span @click="clickLook(item)">查看</span>
        <span @click="deleteBind(item)">删除</span> -->
      </div>
      </div>

    </div>
    <div class="btn-wrap" v-if="bindSchoolList.length<3">
      <div class="add-btn" @click="isShowAdd = true">新增关注</div>
    </div>
    <div class="card" v-if="isShowAdd">
      <div class="hang1">
        <img :src="userInfo.headImgUrl" alt />
        <div class="right">
          <div class="nick-name">{{userInfo.nickname}}</div>
          <div class="radios">
              <el-radio class="el-radio" v-model="form.bindType" label="bind_type_parents">家长</el-radio>
              <el-radio class="el-radio" v-model="form.bindType" label="bind_type_teacher">老师</el-radio>
          </div>
        </div>

      </div>

      <div class="input-hang">
        <span class="label">姓名：</span>
        <el-input size="small" style="width:80%" v-model="form.name" placeholder="请输入姓名" clearable></el-input>
      </div>

      <div class="input-hang">
        <span class="label">关注学校：</span>
        <el-select
          size="small"
          style="width:80%"
          v-model="form.schoolId"
          placeholder="请输入大屏显示的学校名称"
          filterable
          remote
          :remote-method="inputSchoolName"
          :loading="loading"
          v-show="isShowSelect"
          @change="isShowSelect = false"
          no-data-text="至少输入4个字或无数据"
          ref="select"
          @focus="clear"
          @hook:mounted="clear"
          @visible-change="clear"
        >
          <el-option
            v-for="item in schoolIdOptions"
            :key="item.id"
            :label="item.schoolName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          type="textarea"
          autosize
          placeholder="请输入内容"
          v-show="!isShowSelect"
          @focus="isShowSelect = true"
          style="width: 80%;"
          v-model="selectedSchoolName">
        </el-input>
      </div>
      <div class="btns">
        <div class="save-btn" @click="save">保存</div>
        <div class="cancel-btn" @click="isShowAdd = false">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getJsTicket,
  getUserInfo,
  listBySchoolName,
  schoolwechatbind,
  schoolwechatbindList,
  schoolwechatUnbind,
} from "@/api/api.js";

export default {
  computed:{
    selectedSchoolName(){
      return this.schoolIdOptions.find(item => item.id == this.form.schoolId)?.schoolName
    }
  },
  data() {
    return {
      appId: "",
      code: "",
      userInfo: {
        openid: "",
        nickname: "",
        sex: 0,
        headImgUrl: "",
      },
      // 绑定时的参数
      form: {
        wechatUserOpenid: "",
        wechatUserAvatar: "",
        wechatUserNickname: "",
        schoolId: "",
        bindType: "",
        name: "",
      },
      isShowAdd: false,
      schoolIdOptions: [],
      loading: false,

      bindSchoolList: [],

      isShowSelect: true,   // 是否显示下拉框，还是文本框
    };
  },
  methods: {
    async getAppId() {
      const thisPageUrl = location.href.split("#")[0];
      const res = await getJsTicket({
        url: thisPageUrl,
      });
      this.appId = res.appId;
    },
    getCode() {
      // 非静默授权，第一次有弹框
      this.code = "";
      var localHref = window.location.href; // 获取页面url
      this.code = this.getUrlCode().code; // 截取code
      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
          this.appId
        }&redirect_uri=${encodeURIComponent(
          localHref
        )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        // 你自己的业务逻辑
        getUserInfo({ code: this.code }).then((response) => {
          if (response.openid) {
            console.log("openId", response.openid);
            this.userInfo = response;
            this.form.wechatUserNickname = response.nickname;
            this.form.wechatUserOpenid = response.openid;
            this.form.wechatUserAvatar = response.headImgUrl;

            window.localStorage.setItem("openId", response.openid);
            console.log(response.openid);
            window.localStorage.setItem("userInfo", JSON.stringify(response));
            console.log(JSON.stringify(response));

            this.getData();
          }
        });
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      console.log(theRequest);
      return theRequest;
    },

    inputSchoolName(query) {
      if (query && query.length >= 4) {
        this.loading = true;
        listBySchoolName({ schoolName: query }).then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.schoolIdOptions = res.data;
          }
        });
      } else {
        this.schoolIdOptions = [];
      }
    },

    // 绑定学校保存
    save() {
      // 表单验证
      if (!this.form.bindType) {
        this.$toast.fail("请选择角色");
        return;
      }
      if (!this.form.name) {
        this.$toast.fail("请输入姓名");
        return;
      }
      if (!this.form.schoolId) {
        this.$toast.fail("请输入学校名称");
        return;
      }
      schoolwechatbind(this.form).then((res) => {
        if (res.code == 200) {
          this.$toast.success("关注成功！");
          this.getData();
          this.isShowAdd = false;
        }
      });
    },

    getData() {
      schoolwechatbindList({ openId: this.userInfo.openid }).then((res) => {
        if (res.code == 200) {
          this.bindSchoolList = res.data;
        }
      });
    },

    deleteBind(item) {
      this.$dialog
        .confirm({
          title: "删除关注",
          message: `是否确定删除${item.schoolName}的关注?`,
        })
        .then(() => {
          schoolwechatUnbind({ id: item.id }).then((res) => {
            if (res.code == 200) {
              this.$toast.success("删除关注成功！");
              this.getData();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    clickLook(item){
      this.$router.push(`/wechat1/${item.schoolNo}`)
    },      
    // 进入线上放学页面
    clickAfterSchool(item){
      this.$router.push(`/wechat1-onLineLetOut/${item.schoolNo}`)
    },
    // ios的兼容性问题，解决el-select不能唤起键盘
    clear(async) {
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题
          setTimeout(() => {
            const { select } = this.$refs
            const input = select.$el.querySelector('.el-input__inner')
            input.removeAttribute('readonly')
          }, 200)
        }
      })
    }
  },

  async mounted() {
    function fontSize() {
      var deviceWidth = document.documentElement.clientWidth;
      document.documentElement.style.fontSize = deviceWidth / 37.5 + "px";
      // console.log(deviceWidth / 37.5 + "px");
    }
    fontSize();
    window.onresize = fontSize;

    // 获取AppId
    await this.getAppId();
    // 如果缓存localStorage中没有微信openId，则需用code去后台获取
    if (!window.localStorage.getItem("openId")) {
      this.getCode();

      // 以下为测试代码
      // let jsonStr =
      //   '{"openid":"oJS726AkgcxIlkwCVGAD3i7y5Yq8","nickname":"东之旭","sex":0,"city":"","province":"","country":"","headImgUrl":"https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKT2SPcDX5mKs5meho1uosib3MdiccQaORXicNtOtO6ibvDezs8ZzwHg1Z4WoIw9BpB6LtRgGgNO18TTA/132","unionId":null,"privileges":[]}';
      // window.localStorage.setItem("openId", "oJS726AkgcxIlkwCVGAD3i7y5Yq8");
      // window.localStorage.setItem("userInfo", jsonStr);


    } else {
      // localStorage中存了用户信息
      let response = JSON.parse(window.localStorage.getItem("userInfo"));
      this.form.wechatUserNickname = response.nickname;
      this.form.wechatUserOpenid = response.openid;
      this.form.wechatUserAvatar = response.headImgUrl;
      this.userInfo = response;
      this.getData();
    }

    
  },
};
</script>

<style lang='scss' scoped>
* {
  box-sizing: border-box;
}
.homePage {
  width: 100vw;
  height: 100vh;
  min-height: 60rem;
  padding: 1rem;
  font-size: 1.6rem;
  color: #737373;
  .school-item {
    margin-top: 2rem;
    height: 30vw;
    padding: 0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    border-radius: 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 0.2rem 1.2rem 0 rgba(0, 0, 0, 0.1);
    border: 0.1rem solid #ebeef5;

    img {
      width: 16vw;
      height: 16vw;
      border-radius: 1rem;
    }
    .names{
      display: flex;
      width: 70vw;
      .nick-name {
        width: 30%;
      }
      .school-name {
        width: 70%;
      }
    }

    .buttons {
      width: 100%;
      height: 20%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 1.4rem;
      color: #60c290;
      margin-top: 1.5rem;
      padding: 0 1.5rem;
    }
  }
  .btn-wrap {
    margin-top: 2rem;
    height: 6%;
    .add-btn {
      width: 50%;
      height: 100%;
      background: #60c290;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 1.5rem;
      color: white;
    }
  }
  .card {
    margin-top: 2rem;
    height: 40%;
    border: 1px solid #ebebeb;
    padding: 1rem;
    border-radius: 1.5rem;
    .hang1 {
      height: 30%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      img {
        width: 16vw;
        height: 16vw;
        border-radius: 1rem;
      }
      .right{
        .nick-name{
          text-align: center;
        }
        .radios {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          margin-top: 1.5rem;

          ::v-deep .el-radio__label{
            font-size: 16px;
            font-weight: bold;
          }
        }
      }

    }

    .input-hang {
      height: 20%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .label {
        width: 30%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
    .btns {
      margin-top: 2rem;
      height: 15%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .save-btn {
        width: 30%;
        height: 100%;
        background: #60c290;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        border-radius: 1rem;
        color: white;
        font-weight: lighter;
      }
      .cancel-btn {
        width: 30%;
        height: 100%;
        background: #5e5f62;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        border-radius: 1rem;
        color: white;
        font-weight: lighter;
      }
    }
  }
}
</style>